export default {
    Skeleton: {
        baseStyle: {},
        sizes: {},
        variants: { 
            default: {
                startColor: "secondary,50",
                endColor: "secondary.100"
            }
        },
        defaultProps: {
            variant: "default"
        },
    }
};
